import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material'
import { FC, useRef, useState } from 'react'
import { PrimaryDots } from '../../assets/images'
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants'
import { ReportStatus } from '../../../generated'

interface ReportsMenuProps {
  reportId: string
  status: ReportStatus
  refetch: () => void
  onPrint: () => void
  onDownloadCSV: () => void
  onDownloadPDF: () => void
  onRetry: () => void
  onCancel: () => void
}

export const ReportsMenu: FC<ReportsMenuProps> = ({
  reportId,
  status,
  refetch,
  onPrint,
  onDownloadCSV,
  onDownloadPDF,
  onRetry,
  onCancel
}): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const handleClick = () => setOpen(!open)
  const handleClose = () => setOpen(false)

  const isUncompleted = status === ReportStatus.Failed || status === ReportStatus.Cancelled

  return (
    <Box>
      <IconButton
        ref={anchorRef}
        id={`report-menu-button-${reportId}`}
        aria-controls={`report-menu-${reportId}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      {status === ReportStatus.Completed && (
        <Menu
          id={`report-menu-${reportId}`}
          anchorEl={anchorRef.current}
          open={open}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          onClose={handleClose}
          PaperProps={menuPaperStyles}
        >
          <MenuItem
            onClick={() => {
              handleClose()
              onPrint()
            }}
          >
            Print to Screen
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose()
              onDownloadCSV()
            }}
          >
            Download as .CSV
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose()
              onDownloadPDF()
            }}
          >
            Download as PDF
          </MenuItem>
        </Menu>
      )}

      {status === ReportStatus.InProgress && (
        <Menu
          id={`report-menu-${reportId}`}
          anchorEl={anchorRef.current}
          open={open}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          onClose={handleClose}
          PaperProps={menuPaperStyles}
        >
          <MenuItem
            onClick={() => {
              handleClose()
              refetch()
            }}
          >
            Refresh
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose()
              onRetry()
            }}
          >
            Retry
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose()
              onCancel()
            }}
          >
            Cancel
          </MenuItem>
        </Menu>
      )}

      {isUncompleted && (
        <Menu
          id={`report-menu-${reportId}`}
          anchorEl={anchorRef.current}
          open={open}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          onClose={handleClose}
          PaperProps={menuPaperStyles}
        >
          <MenuItem
            onClick={() => {
              handleClose()
              onRetry()
            }}
          >
            Retry
          </MenuItem>
        </Menu>
      )}
    </Box>
  )
}
